/* eslint-disable camelcase */
export default class ConstructorRecommendationsService {

	/**
	 * @returns {string}
	 */
	get apiURL () {
		return window.mivaJS?.Japi_Url;
	}

	/**
	 * @param {import('../api/constructor/lib/transform-recommendations-response').RecommendationItem[]} items
	 * @param {number} limit
	 * @param {Record<string, string>} requestParams
	 * @param {string} [recommendationType]
	 * @returns {Promise<{products?: object[], success?: number}>}
	 */
	async recommendationsDataRequest (items, limit = 10, requestParams = {}, recommendationType = '') {
		if (!this.apiURL || !items?.length) {
			return {};
		}

		const requestBody = {
			function: 'constructor-recommendations',
			limit: limit,
			recommendations: items.map(item => {
				return {
					id: item.id
				};
			}),
			...recommendationType ? {recommendation_type: recommendationType} : {}
		};

		const url = this.addParamsToUrl(this.apiURL, requestParams);

		const response = await fetch(url, {
			body: JSON.stringify(requestBody),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		if (!response.ok) {
			console.warn(`Recommendations failed with status ${response.status}`);

			return {};
		}

		const recommendationData = await response.json();

		if (recommendationData.success !== 1) {
			console.warn('Recommendations returned success 0', recommendationData);

			return {};
		}

		if (!recommendationData.products?.length) {
			return {};
		}

		return recommendationData;
	}

	addParamsToUrl = (url, params) => {
		const urlObj = new URL(url);

		Object.entries(params).forEach(([
			key,
			value
		]) => {
			if (typeof value === 'undefined' || value === null || value === '') {
				return;
			}

			urlObj.searchParams.set(key, value);
		});

		return urlObj.toString();
	};
}
